function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { sans as zoram, fontSize28, fontSize32, lineHeightTight, fontWeightLight } from "@churchofjesuschrist/eden-style-constants";
import { mediaBreak600w } from "@churchofjesuschrist/eden-styled-helpers";
export const internalUseOnlyPriority2 = css(["margin:0;font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";"], zoram, fontWeightLight, lineHeightTight, fontSize28, props => props.small ? "" : mediaBreak600w`font-size: ${fontSize32};`);
const H2Styled = styled.h2.withConfig({
  componentId: "sc-42v4-0"
})(["", ";"], internalUseOnlyPriority2);

const H2 = _ref => {
  let {
    small,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(H2Styled, _extends({
    small: small
  }, props), children);
};

export default H2;
H2.propTypes = {
  /** Content inside heading */
  children: PropTypes.node.isRequired,

  /** Whether smaller styles should be applied */
  small: PropTypes.bool
};